module.exports = __webpack_public_path__ + "static/img/normal@2x.87ae0528.png";